import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import currentIcons from './icons/_index.jsx';
import deprecatedIcons from './icons/deprecated/_index.jsx';
import utilityIcons from './icons/utility/_index.jsx';

import createKey from '../../util/createKey.js';

export default function LdsIcon({
  name,
  inline = false,
  decorative,
  description,
  label,
  className,
  ...rest
}) {
  const icons = {
    ...currentIcons,
    ...deprecatedIcons,
    ...utilityIcons,
  };

  function getIconFromName() {
    if (Object.hasOwn(currentIcons, name)) return icons[name];

    if (Object.hasOwn(deprecatedIcons, name)) {
      // eslint-disable-next-line no-console
      console.warn(`LdsIcon attempted to render an icon named: "${name}" - IT HAS BEEN DEPRECATED AND MAY BE REMOVED IN THE NEXT MAJOR OR MINOR VERSION; please check the LDS Icon documentation for a compatible current icon to replace it with.`);
      return icons[name];
    }

    if (Object.hasOwn(utilityIcons, name)) {
      return icons[name];
    }

    // eslint-disable-next-line no-console
    console.error(`LdsIcon attempted to render an icon named: "${name}" - this name is invalid; it may have been deprecated and removed or it may never have existed. Please check the LDS Icon documentation to ensure the icon name is spelled correctly and is in Pascal casing or to otherwise select an appropriate available icon.`);
    return icons.LDS_IconError;
  }

  const Icon = getIconFromName();
  const [iconId, setIconId] = useState('');

  useEffect(() => (setIconId(createKey())), []);

  return (
    <svg
      className={cn(
        'lds-icon',
        `icon-${name}`,
        {
          inline,
        },
        className
      )}
      aria-hidden={decorative}
      role="img"
      focusable="false"
      aria-labelledby={`lds-icon-${name}-title-${iconId} lds-icon-${name}-description-${iconId}`}
      {...rest}
    >
      <title
        id={`lds-icon-${name}-title-${iconId}`}
      >
        {label || name}
      </title>
      <desc
        id={`lds-icon-${name}-description-${iconId}`}
      >
        {description}
      </desc>
      <Icon />
    </svg>
  );
}

LdsIcon.propTypes = {
  name: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  decorative: PropTypes.bool,
  description: PropTypes.string,
  label: PropTypes.string,
};
